import type ComposeViewState from '../store/schema/ComposeViewState';
import type { AttachmentWellViewState } from 'mini-attachment-well-data';
import { mutatorAction } from 'satcheljs';

export const setAttachmentWellValue = mutatorAction(
    'setAttachmentWellValue',
    (attachmentWell: AttachmentWellViewState, viewState: ComposeViewState) => {
        viewState.attachmentWell = attachmentWell;
    }
);
